<template>
  <div id="app" class="mobile">
    <b-row class="Sidebar">
      <b-button v-b-toggle.sidebar-1 class="btn-side">
        <b-icon font-scale="2" style="width:100%;color: #fff;margin-top:5px" icon="justify"></b-icon>
      </b-button>
    </b-row>
    <router-view />
    <SideBar></SideBar>
    <a id="carrier-link" href="https://pennlogisticsllc.mycarrierlink.com/referral/zn9t6taz">
      <img src="./img/whatsapp.png" width="20" height="20">
      Carrier onboarding
    </a>
  </div>
</template>
<script>
import SideBar from './components/SideBar.vue'
export default {
  components: { SideBar }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#carrier-link {
  position: fixed;
  font-family: Gilroy-SemiBold;
  font-size: 16px;
  z-index: 100;
  bottom: 20px;
  right: 20px;
  background: #2867EC;
  background: linear-gradient(90deg, rgba(233, 150, 55, 1) 0%, rgba(44, 181, 230, 1) 50%, rgba(40, 103, 236, 1) 100%);
  color: white;
  padding: 8px 14px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, .3);
}

#carrier-link:hover {
  text-decoration: none;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.4);
}

#chatra.chatra--side-bottom {
  bottom: 70px !important;
}

</style>
